/**
 * Arabic for build 6: the flight-record figures a person enters by hand —
 * actual times, loads, delay codes, the committed off-block time, a flight
 * not on the schedule — the stand and gate register's form, and the
 * passenger-flow assumption label. The IATA delay code names follow AHM 730
 * in plain words. Proposed; pending native aviation review.
 */
const ar: Record<string, string> = {
  /* where a figure came from */
  "from the MVT": "من رسالة الحركة MVT",
  "from the AIDX feed": "من تغذية AIDX",
  "from a feed": "من تغذية بيانات",
  "from the schedule": "من الجدول",
  "by hand": "يدويًا",
  "by hand · {who}": "يدويًا · {who}",
  "from MVT": "من MVT",

  /* the AODB panel */
  "Add a flight": "إضافة رحلة",
  "A flight that isn't on the schedule": "رحلة غير موجودة في الجدول",
  Bags: "الأمتعة",
  "Cargo (kg)": "الشحن (كغ)",
  "Committed: {t}. A new time replaces it; the history keeps both.":
    "الوقت الملتزم به: {t}. الوقت الجديد يحل محله، ويحتفظ السجل بالاثنين.",
  "No committed time yet.": "لا يوجد وقت ملتزم به بعد.",
  "Saved to the record.": "حُفظ في السجل.",
  "It replaces what the {src} said.": "ويحل محل ما ورد في {src}.",
  "{v} is not a time; type it as HH:MM, like 14:35.": "{v} ليس وقتًا؛ اكتبه بصيغة HH:MM، مثل 14:35.",

  /* actual times */
  "Actual times": "الأوقات الفعلية",
  "Off-block (local HH:MM)": "مغادرة الموقف (بالتوقيت المحلي HH:MM)",
  "Take-off (local HH:MM)": "الإقلاع (بالتوقيت المحلي HH:MM)",
  "Landing (local HH:MM)": "الهبوط (بالتوقيت المحلي HH:MM)",
  "On-block (local HH:MM)": "الوصول إلى الموقف (بالتوقيت المحلي HH:MM)",
  "Why entered by hand": "سبب الإدخال اليدوي",
  "no MVT came, the handler's log …": "لم تصل رسالة MVT، سجل المناولة …",
  "Save actual times": "حفظ الأوقات الفعلية",
  "Type a time to save it.": "اكتب وقتًا لحفظه.",

  /* loads */
  Loads: "الحمولات",
  "Bags (pieces)": "الأمتعة (قطع)",
  "Mail (kg)": "البريد (كغ)",
  Seats: "المقاعد",
  "Where the figures came from": "مصدر الأرقام",
  "the load sheet, the handler …": "ورقة الحمولة، المناول …",
  "Save loads": "حفظ الحمولات",
  "Change a figure to save it. Clear one to remove it.": "غيّر رقمًا لحفظه. امسح رقمًا لإزالته.",

  /* delay codes */
  "IATA code": "رمز IATA",
  "Flew {n} min late. The minutes should add up to that.":
    "أقلعت متأخرة {n} دقيقة. يجب أن يكون مجموع الدقائق مساويًا لذلك.",
  "Flew on time.": "أقلعت في موعدها.",
  "Add a code": "إضافة رمز",
  "{n} min in all": "{n} دقيقة إجمالًا",
  "the airline's delay report …": "تقرير التأخير من شركة الطيران …",
  "Save delay codes": "حفظ رموز التأخير",

  /* the committed off-block time */
  "Committed off-block (local HH:MM)": "وقت المغادرة الملتزم به (بالتوقيت المحلي HH:MM)",
  "Given by": "مقدَّم من",
  "the handler or airline": "المناول أو شركة الطيران",
  "Save committed time": "حفظ الوقت الملتزم به",
  "Committed off-block time": "وقت المغادرة الملتزم به",
  "{f}, as the handler gave it": "{f}، كما قدّمه المناول",
  "Committed now: {t}. A new time replaces it; the record keeps both.":
    "الملتزم به الآن: {t}. الوقت الجديد يحل محله، ويحتفظ السجل بالاثنين.",
  "No committed time yet. Scheduled off-block is {t}.": "لا يوجد وقت ملتزم به بعد. موعد المغادرة المجدول {t}.",
  Enter: "إدخال",

  /* a flight not on the schedule */
  Direction: "الاتجاه",
  "Airline code": "رمز شركة الطيران",
  "Scheduled (local HH:MM)": "المجدول (بالتوقيت المحلي HH:MM)",
  "From (airport code)": "من (رمز المطار)",
  "To (airport code)": "إلى (رمز المطار)",
  Military: "عسكرية",
  "Why it isn't on the schedule": "سبب عدم وجودها في الجدول",
  "a charter, a diversion, an extra section": "رحلة مستأجرة، تحويل، رحلة إضافية",
  "Add to the record": "إضافة إلى السجل",
  "{f} is on the record.": "{f} مسجّلة في السجل.",

  /* the register */
  "Resource kind": "نوع المورد",
  "What the plan can use. Pick one to change it.": "ما يمكن للخطة استخدامه. اختر واحدًا لتغييره.",
  Largest: "الأكبر",
  "Its gate": "بوابته",
  Uses: "الاستخدامات",
  "Bus gate": "بوابة حافلات",
  "On the register": "في السجل",
  "off the register": "خارج السجل",
  "Change {code}": "تغيير {code}",
  "pier, island or hall": "الرصيف أو الجزيرة أو الصالة",
  "Largest size": "أكبر حجم",
  "code {x}": "الفئة {x}",
  "Its gate (codes)": "بوابته (رموز)",
  "Can't be used with (codes)": "لا يُستخدم مع (رموز)",
  "Contact stand: people walk through a bridge": "موقف متصل: يمشي الركاب عبر جسر",
  "Uses (none ticked: any)": "الاستخدامات (بلا تحديد: أي استخدام)",
  "Bus gate: serves remote stands by bus": "بوابة حافلات: تخدم المواقف البعيدة بالحافلة",
  "On the register (untick to stop the plan using it)": "في السجل (ألغِ التحديد لإيقاف استخدامه في الخطة)",
  "new chart, works, a new bridge …": "مخطط جديد، أعمال، جسر جديد …",
  "Save the change": "حفظ التغيير",
  "Change a field to save it.": "غيّر حقلًا لحفظه.",
  "Saved. The plan is checked again.": "حُفظ. تُراجع الخطة من جديد.",
  "Nothing changed.": "لم يتغير شيء.",

  /* passenger flow: the seats assumption */
  "No load on the record: {p}% of the seats is assumed.": "لا توجد حمولة في السجل: يُفترض {p}% من المقاعد.",
  "{n} flight has no load on the record.|{n} flights have no load on the record.":
    "لا توجد رحلات بلا حمولة في السجل.|رحلة واحدة بلا حمولة في السجل.|رحلتان بلا حمولة في السجل.|{n} رحلات بلا حمولة في السجل.|{n} رحلة بلا حمولة في السجل.|{n} رحلة بلا حمولة في السجل.",
  "{p}% of the seats is assumed for them. Enter loads on Flight record.":
    "يُفترض لها {p}% من المقاعد. أدخل الحمولات في سجل الرحلات.",

  /* IATA delay codes (AHM 730) */
  "Airline internal code": "رمز داخلي لشركة الطيران",
  "No gate or stand, own airline activity": "لا بوابة ولا موقف بسبب نشاط الشركة نفسها",
  "Scheduled ground time under the minimum": "وقت أرضي مجدول أقل من الحد الأدنى",
  "Late check-in, after the deadline": "تسجيل متأخر بعد الموعد النهائي",
  "Late check-in, congestion": "تسجيل متأخر بسبب الازدحام",
  "Check-in error": "خطأ في التسجيل",
  "Oversales or booking error": "بيع زائد أو خطأ في الحجز",
  "Boarding: missing or late travellers": "الصعود: مسافرون مفقودون أو متأخرون",
  "Commercial request, VIP or press": "طلب تجاري أو كبار الشخصيات أو الصحافة",
  "Catering order late or wrong": "طلب التموين متأخر أو خاطئ",
  "Bag processing": "معالجة الأمتعة",
  "Reduced mobility, boarding or leaving": "ذوو الحركة المحدودة: الصعود أو النزول",
  "Cargo documents": "مستندات الشحن",
  "Cargo late to the hold": "تأخر الشحن إلى العنبر",
  "Cargo accepted late": "قبول الشحن متأخرًا",
  "Cargo packing": "تغليف الشحن",
  "Cargo oversales": "بيع زائد للشحن",
  "Cargo prepared late": "تجهيز الشحن متأخرًا",
  "Mail documents or packing": "مستندات البريد أو تغليفه",
  "Mail late to the hold": "تأخر البريد إلى العنبر",
  "Mail accepted late": "قبول البريد متأخرًا",
  "Load documents late or wrong": "مستندات الحمولة متأخرة أو خاطئة",
  "Loading or unloading": "التحميل أو التفريغ",
  "Loading equipment": "معدات التحميل",
  "Servicing equipment": "معدات الخدمة",
  "Fueling or defueling": "التزود بالوقود أو تفريغه",
  "Catering delivered or loaded late": "تأخر توصيل التموين أو تحميله",
  "Containers (ULD)": "الحاويات (ULD)",
  "Technical ground equipment": "المعدات الأرضية الفنية",
  "Scheduled maintenance, late release": "صيانة مجدولة وتأخر الإفراج",
  "Unscheduled maintenance": "صيانة غير مجدولة",
  "Spares and maintenance equipment": "قطع الغيار ومعدات الصيانة",
  "AOG spares": "قطع غيار لطائرة متوقفة (AOG)",
  "Change of unit, technical": "تغيير الطائرة لأسباب فنية",
  "Standby unit": "طائرة احتياطية",
  "Cabin layout change": "تغيير تهيئة المقصورة",
  "Damage in flight": "ضرر أثناء الطيران",
  "Damage on the ground": "ضرر على الأرض",
  "Departure control system": "نظام مراقبة المغادرة",
  "Cargo system": "نظام الشحن",
  "Flight plan system": "نظام خطة الطيران",
  "Other system": "نظام آخر",
  "Flight plan late or changed": "خطة الطيران متأخرة أو معدلة",
  "Fuel or load change": "تغيير الوقود أو الحمولة",
  "Crew late or procedures": "تأخر الطاقم أو الإجراءات",
  "Flight crew shortage": "نقص في طاقم القيادة",
  "Flight crew request": "طلب من طاقم القيادة",
  "Cabin crew late": "تأخر طاقم المقصورة",
  "Cabin crew shortage": "نقص في طاقم المقصورة",
  "Cabin crew error or request": "خطأ أو طلب من طاقم المقصورة",
  "Captain's security check": "فحص أمني بطلب من القائد",
  "Weather at departure": "الطقس في مطار المغادرة",
  "Weather at destination": "الطقس في مطار الوصول",
  "Weather en route or alternate": "الطقس على المسار أو في المطار البديل",
  "Snow, ice, water or sand removal": "إزالة الثلج أو الجليد أو المياه أو الرمال",
  "Ground handling slowed by weather": "بطء المناولة الأرضية بسبب الطقس",
  "Flow control, en-route demand": "تنظيم التدفق: الطلب على المسار",
  "Flow control, ATC staff or equipment": "تنظيم التدفق: موظفو أو معدات المراقبة الجوية",
  "Flow control, destination restriction": "تنظيم التدفق: قيود في مطار الوصول",
  "Flow control, weather at destination": "تنظيم التدفق: الطقس في مطار الوصول",
  "Mandatory security": "إجراءات أمنية إلزامية",
  "Immigration, customs or health": "الجوازات أو الجمارك أو الصحة",
  "Restrictions at the destination airport": "قيود في مطار الوصول",
  "Restrictions at the departure airport": "قيود في مطار المغادرة",
  "Waiting for connecting load": "انتظار حمولة الربط",
  "Through check-in error": "خطأ في التسجيل المباشر للرحلات المتصلة",
  "Late inbound unit (rotation)": "تأخر الطائرة القادمة (التدوير)",
  "Cabin crew rotation": "تدوير طاقم المقصورة",
  "Crew rotation": "تدوير الطاقم",
  "Industrial action, own airline": "إضراب داخل الشركة",
  "Industrial action, others": "إضراب لدى جهات أخرى",
};

export default ar;
